module.exports = __webpack_public_path__ + "img/verified.d305c1be.svg";